import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

//Redux Action
import { openSocialShareModal } from '../../../actions/modalActions';

// Translation
import { FormattedMessage, useIntl } from 'react-intl';

// Locale
import messages from '../../../locale/messages';
import WishListIcon from '../../WishListIcon';

// Component
import StarRating from '../../StarRating/StarRating';

//Image
import shareIcon from '/public/SiteIcons/viewListingShareIcon.svg';
import personajeLupa from '/public/SiteImages/personaje-lupa.svg';

// Style
import s from './HostDetails.css';
import cs from '../../commonStyle.css';

const HostDetails = ({ data, loading, reviewsCount, reviewsStarRating }) => {

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  let starRatingValue = 0, isListOwner, wishListStatus;

  if (reviewsCount > 0 && reviewsStarRating > 0) {
    starRatingValue = Math.round(reviewsStarRating / reviewsCount)
  }
  isListOwner = data.isListOwner;
  wishListStatus = data.wishListStatus;

  return (
    <div className={cx(s.paddingCss, s.hostFlex)}>
      <div className={s.flex}>
        <h1 className={cx(s.titleText)}>
          {data.title ? data.title : data.settingsData && data.settingsData.length > 0 && data.settingsData[0].listsettings && data.settingsData[0].listsettings.itemName + ' ' + formatMessage(messages.in) + ' ' + data.city}
        </h1>
        <img src={personajeLupa} className={s.lupaCharacter} alt="" />
        {/* <div className={cx(s.buttonContainer, cs.spaceTop3)}>
          {starRatingValue > 0 && <><StarRating className={s.starRatingIconContainer} name={'review'} value={starRatingValue} />
            <span className={cx(s.countGap, 'countGapRTL')}>{starRatingValue}</span></>}
          <span className={cx('locationCssRTL', 'locationCssDarkMode', { [s.locationCss]: starRatingValue > 0 })}>{data.city && data.city.toString().trimEnd()}, {data.state && data.state.toString().trimEnd()}, {data.country === 'BO' ? 'Bolivia': data.country}</span>
        </div> */}
      </div>
      {/* <div className={cx(s.saveButtonPosition)}>
        {!isListOwner && !loading && <WishListIcon type="button" listId={data.id} key={data.id} isChecked={wishListStatus} isViewListing={true} />}
        {
          <div
            className={cx(s.buttonContainer, { [s.mobilePaddingRemove]: isListOwner })}
            onClick={() => dispatch(openSocialShareModal())}
          >
            <span className={cx(s.imgCss, 'svgImg')}><img src={shareIcon} /></span>
            <span className={cs.flexShrinkNone}><FormattedMessage {...messages.shareLabel} /></span>
          </div>
        }
      </div> */}
    </div>
  );
}

HostDetails.propTypes = {
  data: PropTypes.object,
  formatMessage: PropTypes.any,
  reviewsCount: PropTypes.number.isRequired,
  reviewsStarRating: PropTypes.number.isRequired,
};

export default withStyles(s, cs)(HostDetails);
